import React from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 1em;
`;

const Col = styled.div`
  text-align: center;
`;

const Label = styled.div`
  font-weight: 500;
`;

const Value = styled.div`
  font-size: 36px;
  color: #747c84;
`;

const TestText = styled.p`
  margin-top: 8px;
  padding: 8px;
  font-size: smaller;
  white-space: break-spaces;
  text-align: justify;
  display: flex;
  border: 1px solid #d0d6da;
  border-radius: 4px;
  background: #f7f9fa;
  color: #747c84;
`;

export default function TypingTest({
  serviceCallRequest: {
    errorCount,
    elapsedSeconds,
    textLength,
    totalTextLength,
    text
  }
}) {
  const { t } = useTranslation(["opportunity"]);

  try {
    const totalWrittenChars = textLength + errorCount;
    const words = (text.match(/\S+/g) || "").length;
    const copiedText = Math.round((textLength * 100) / totalTextLength);
    const elapsedMinutes = Math.ceil(elapsedSeconds / 60) || 1;
    const charsPerMin = Math.round(totalWrittenChars / elapsedMinutes);
    const wordsPerMin = Math.round(words / elapsedMinutes);
    const error = Math.round((errorCount * 100) / totalWrittenChars);
    const accuracy = 100 - error;

    return (
      <>
        <Wrapper>
          <Col>
            <Label>
              {t("opportunity:process.candidateDetails.typing-worcket.time")}
            </Label>
            <Value>{`${elapsedSeconds}s`}</Value>
          </Col>
          <Col>
            <Label>
              {t(
                "opportunity:process.candidateDetails.typing-worcket.accuracy"
              )}
            </Label>
            <Value>{`${accuracy}%`}</Value>
          </Col>
          <Col>
            <Label>
              {t(
                "opportunity:process.candidateDetails.typing-worcket.copiedText"
              )}
            </Label>
            <Value>{`${copiedText}%`}</Value>
          </Col>
          <Col>
            <Label>
              {t(
                "opportunity:process.candidateDetails.typing-worcket.charsPerMin"
              )}
            </Label>
            <Value>{charsPerMin}</Value>
          </Col>
          <Col>
            <Label>
              {t(
                "opportunity:process.candidateDetails.typing-worcket.wordsPerMin"
              )}
            </Label>
            <Value>{wordsPerMin}</Value>
          </Col>
          <Col>
            <Label>
              {t("opportunity:process.candidateDetails.typing-worcket.errors")}
            </Label>
            <Value>{errorCount}</Value>
          </Col>
          <Col>
            <Label>
              {t("opportunity:process.candidateDetails.typing-worcket.error")}
            </Label>
            <Value>{`${error}%`}</Value>
          </Col>
        </Wrapper>
        <Label>
          {t("opportunity:process.candidateDetails.typing-worcket.text")}
        </Label>
        <TestText>{text}</TestText>
      </>
    );
  } catch (e) {
    console.error(e);
    return (
      <div>
        <p>{t("opportunity:process.candidateDetails.testVisualizeError")}</p>
      </div>
    );
  }
}
